import WizardStepMixin from '../WizardStepMixin';
import props from './ChooseInstallableMixin.props';
import ChooseInstallableForFeature from './ChooseInstallableForFeature/ChooseInstallableForFeature.vue';

export default {
	mixins: [WizardStepMixin],
	props,
	components: { ChooseInstallableForFeature },
	computed: {
		selectedInstallable: {
			get() {
				return this.installablesOptions.find((ins) => ins.id === this.selectedInstallableId);
			},
			set(installableId) {
				this.updateState({ key: 'selectedInstallableId', value: installableId });
			},
		},
	},
	methods: {
		chooseInstallable(installableId) {
			this.selectedInstallable = installableId;
			this.nextStep();
		},
	},
};
